import React from "react"
import { cn } from "../../utils/cn"

const fieldBase =
    "block w-full rounded-lg bg-elevated border border-border text-text text-sm " +
    "placeholder:text-subtle transition-colors " +
    "focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/40 " +
    "disabled:opacity-50 disabled:cursor-not-allowed"

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    invalid?: boolean
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, invalid, ...props }, ref) => (
        <input
            ref={ref}
            className={cn(
                fieldBase,
                "px-3 py-2",
                invalid && "border-danger focus:border-danger focus:ring-danger/40",
                className
            )}
            {...props}
        />
    )
)
Input.displayName = "Input"

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
    ({ className, children, ...props }, ref) => (
        <select
            ref={ref}
            className={cn(fieldBase, "px-3 py-2 pr-8", className)}
            {...props}
        >
            {children}
        </select>
    )
)
Select.displayName = "Select"

export default Input
